module.exports = __webpack_public_path__ + "img/vitrafy-logo-white.104e91eb.png";